module.exports = __webpack_public_path__ + "img/DC_StVincent_0006.30495f34.jpg";